const RequestAndroidAccountDeletionPage: React.FC = () => (
  <div className="prose flex w-full flex-col px-12 py-12">
    <h1>Request Android Account Deletion</h1>
    <p>
      If you would like to request the deletion of your
      account, please contact us at{' '}
      <a href="mailto:jacob.samps@gmail.com">
        jacob.samps@gmail.com
      </a>
    </p>
  </div>
)

export default RequestAndroidAccountDeletionPage
